import React, { useEffect } from 'react';
import { Outlet, NavLink, useLocation, useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../store';
import { useOrgStore } from '../store/org';
import { DemoBanner, EnteringOverlay, OrgChip, VpState } from './VelopulseShell';
import AccountMenu from './AccountMenu';
import useLoad from '../utils/useLoad';
import { vpApi, errorMessage, isUnavailable } from '../api/velopulse';
import '../velopulse.css';

export function PlatformGate({ children }) {
  const { data, error, loading } = useLoad(() => vpApi.getPlatformMe(), []);
  if (loading) return <div className="vp-standalone"><VpState loading /></div>;
  if (error || !data?.is_platform_admin) {
    const detail = error && !isUnavailable(error)
      ? errorMessage(error, '無法確認平台權限。')
      : '此頁面僅限平台管理員。平台權限與公司管理員、全域超級管理員分開，不會因為你是某家公司的管理員而自動取得。';
    return (
      <div className="vp-standalone">
        <DemoBanner />
        <div className="vp-wrap">
          <h1>沒有平台管理權限</h1>
          <p className="vp-lead">{detail}</p>
          <div className="vp-wrap-actions">
            <Link className="vp-btn" to="/">回工作台</Link>
          </div>
        </div>
      </div>
    );
  }
  return children;
}

export default function PlatformShell() {
  const { user, logout } = useAuthStore();
  const { orgs, fetchOrgs, clearOrg } = useOrgStore();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => { if (orgs === null) fetchOrgs(); }, [orgs, fetchOrgs]);
  useEffect(() => { document.title = 'Velopulse — 平台管理'; }, [location.pathname]);

  const handleLogout = () => { clearOrg(); logout(); navigate('/login'); };
  const navCls = ({ isActive }) => (isActive ? 'active' : undefined);
  const onCompanyDetail = /^\/platform\/companies\//.test(location.pathname);
  const crumb = onCompanyDetail ? '公司詳情 · 成員與權限' : '公司';

  return (
    <div className="vp-root vp-admin vp-platform">
      <aside className="vp-side">
        <div className="vp-brand">Velo<em>pulse</em></div>
        <div className="vp-admin-flag">平台管理</div>
        <nav className="vp-nav" aria-label="平台管理導覽">
          <NavLink to="/platform" end className={navCls}>公司</NavLink>
        </nav>
        <div className="vp-side-foot">
          <Link to="/" className="vp-back-work">回工作台</Link>
          <button type="button" onClick={handleLogout}>登出（{user?.name || '使用者'}）</button>
        </div>
      </aside>
      <div className="vp-main">
        <DemoBanner />
        <header className="vp-top">
          <div className="vp-logo">平台管理</div>
          <div className="vp-crumb">{crumb}</div>
          <div className="vp-spacer" />
          <OrgChip />
          <AccountMenu />
        </header>
        <div className="vp-scroll"><Outlet /></div>
      </div>
      <EnteringOverlay />
    </div>
  );
}
